export default __webpack_public_path__ + "static/media/jogaim_és_kötelezettségeim.72c10126.png";